import { configSumo, logger, LoggerConfig, EnvironmentNames } from '@origin-digital/reporting-client';
import SumoLogger from 'sumo-logger';
import { config } from '../utils/config';

function getEnvironmentNameForEnv(): EnvironmentNames {
  if (
    config.ENV === 'local' ||
    config.ENV === 'dev' ||
    config.ENV === 'test' ||
    config.ENV === 'staging' ||
    config.ENV === 'prod'
  ) {
    return config.ENV;
  } else {
    return 'local';
  }
}

const loggerConfig: LoggerConfig = {
  SumoLogger, // bring your own SumoLogger instance
  sumoLogLevel: 'warn', // error level to send to sumo
  consoleLogLevel: 'none', // error level to log to console
  sendOnErrors: true, // send window.onerror to sumo?
  appName: 'solar-quote',
  endpoint:
    'https://collectors.au.sumologic.com/receiver/v1/http/ZaVnC4dhaV0jpEEuI3pu9KoUfnb7JgspsLOj37Yg0CvMMxXm4Scnpw7NRg93sXbYzApBFvRt_Ow1T4PKPuNi3WNmxA5_08v28cvX208EiJsfp8ik00te7g==',
  sourceEnv: getEnvironmentNameForEnv()
};

if (loggerConfig.sourceEnv === 'local' || loggerConfig.sourceEnv === 'dev' || loggerConfig.sourceEnv === 'test') {
  loggerConfig.sumoLogLevel = 'none';
  loggerConfig.sendOnErrors = false;
  loggerConfig.consoleLogLevel = 'debug';
}

configSumo(loggerConfig);

export default logger;
